/** Join class names, skipping falsy ones: cx('btn', active && 'btn--active'). */
export function cx(...names: (string | false | null | undefined)[]): string {
  return names.filter(Boolean).join(' ')
}
